
import apiWorker from '../apiWorker'

const contacts = {    
    find : () =>  apiWorker('get',  `/v1/api/cases`, null, true),
    findById : (case_id) =>  apiWorker('get',  `/v1/api/cases/${case_id}`, null, true),
}

export default contacts;